import React from 'react';
import {NavLink} from 'react-router-dom';
export default class CampaignBox extends React.Component {
    render() {
        return (
            <div className="row">
            <div className="col-md-3">
                <div className="ibox-content text-center">
                    <h1>Fit India</h1>
                    <div className="m-b-sm ">
                        <img alt="image" className="col-8" style={{"width":"100%"}} src="/img/yoga-banner.jpg" />
                    </div>
                    <p className="font-bold">Picture Share: 26 Apr, 2018</p>

                    <div className="text-center">
                    <NavLink to="/fit-india/manage-videos" className="btn btn-xs btn-primary">Videos</NavLink>&nbsp;
                    <NavLink to="/fit-india/moderation" className="btn btn-xs btn-primary">Moderation</NavLink>&nbsp;
                    
                    </div>
                </div>
            </div>

        </div> )
    }

}


// WEBPACK FOOTER //
// ./src/Components/Pages/Home/CampaignBox.jsx